import { call, put, takeLatest } from 'redux-saga/effects';
import * as url from '../../helpers/url_helper';
import { ShipmentsTypes } from './actionTypes';
import { getShipmentsListSuccess, getShipmentsListFail, getMilestoneConfigSHSuccess, getMilestoneConfigSHFail, GetMilestonesEventsNameSHSuccess, GetMilestonesEventsNameSHFail, GetMilestonesEventsNameSHByGUIDSuccess, GetMilestonesEventsNameSHByGUIDFail, getShipmentsHousesSuccess, getShipmentsHousesFail } from './actions';import { getMilestoneConfigOperation } from '../../helpers/GetMilestoneConfigOperation';

let controller = new AbortController();
let signal = controller.signal;

export const cancelFetchSH = () => {
  controller.abort(); // Esto cancelará la solicitud
  controller = new AbortController(); // Restablecer el controlador para futuras solicitudes
  signal = controller.signal; // Actualizar la señal para futuras solicitudes
};

export const fetchShipments = async (data: any) => {
  const { from, to, order, dynamicFilter, dynamicFilterCF } = data.form;
  const { sizePerPage, page } = data.pagination;

  const path = url.API_URL;
  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
    user = JSON.parse(getAuthUser);
  }

  const query = `query {
    GetShipments(Shipments: {
      userId: ${user.id || ''},
      initial_date: "${from || ''}",
      final_date: "${to + ' 11:59:00' || ''}",
      order : "${order}",
      ${dynamicFilterCF ?? ''}
      ${dynamicFilter ?? ''}
      }, Pagination:{
        sizePage:${sizePerPage},
        actualPage:${page}
      })
      {
        CountItems
        shipmentsData {
          Number
          Name
          id
          clientId
          Int
          AESITNInt
          AESStatus
          AESXTNInt
          AMSActionCode
          AMSNotifyParty1Name
          AMSNotifyParty1SCAC
          AMSNotifyParty2Name
          AMSNotifyParty2SCAC
          AgentPartType
          AirWaybillTotalsInKg
          AirWaybillWeightUnit
          AreShipperConsigneeRelated
          AreaPrecision
          Barcodes
          BillOfLadingGroupSimilarItems
          BillOfLadingWeightUnit
          BookingInt
          CargoStorage
          CarrierName
          ConsigneeName
          CreatedByName
          CreatedOn
          CreatorNetworkID
          CutoffDate
          DbClassType
          DeclaredValue
          DeliveryAgentName
          DescriptionOfGoods
          DestinationAgentName
          DestinationPickupEntityName
          DestinationPortSchedule
          Direction
          DoNotUseAgent
          DocumentTemplateName
          EntryInt
          EstimatedArrivalDate
          EstimatedDepartureDate
          ExecutedCityCode
          ExecutedPlace
          FillDocsWithAccountingInfo
          Flags
          GUID
          GenerateCommissionsAsExpenses
          GenerateOneTransactionPerEntity
          GroupChargesInLiquidation
          HasGlobalAgentParticipation
          HasGlobalSalesManParticipation
          InsuranceInt
          IntermediateConsigneeName
          IsAirWayBillDetailExpanded
          IsBillOfLadingDetailExpanded
          IsCargoManifestDetailExpanded
          IsFullContainerLoad
          IsRoutedTransaction
          IsTrackingEmailSent
          IssuedByName
          LastDateOfDeparture
          LastPortOfDepartureSchedule
          LengthPrecision
          LengthUnit
          ManifestInt
          MasterGUID
          MaximumPieces
          ModeOfTransportCode
          Notes
          NotifyPartyName
          OceanCarriersInterfaceMessageVersion
          OriginPortSchedule
          PickupDate
          ProfitOrder
          ReceivedAtNetworkID
          RoutingInstructions
          SalesManPartType
          Service
          ShipperName
          ShowContainerDetails
          ShowDetailsInLiquidation
          ShowDimensionsDetailedInAWB
          ShowDimensionsInAWB
          ShowWHRsInCargoManifest
          SmartBorderInt
          SplitTaxedFromNonTaxedTransactions
          SpottingDate
          Status
          TotalPieces
          TotalVolume
          TotalVolumeWeight
          TotalWeight
          Type
          UseNotesAsMarksIntsInBL
          Version
          VolumePrecision
          VolumeUnit
          VolumeWeightPrecision
          WaybillNotes
          WeightPrecision
          WeightUnit
          DelPort_CodeCity
          DelPort_CodeCountry
          DelPort_City
          DelPort_Country
          DelPort_Notes
          DelPort_DbClassType
          DestPort_CodeCity
          DestPort_CodeCountry
          DestPort_Method
          DestPort_City
          DestPort_Country
          DestPort_Notes
          DestPort_DbClassType
          LastPortDep_CodeCity
          LastPortDep_CodeCountry
          LastPortDep_City
          LastPortDep_Country
          LastPortDep_Notes
          LastPortDep_DbClassType
          LastPortDep_Method
          OrigPort_CodeCity
          OrigPort_CodeCountry
          OrigPort_City
          OrigPort_Country
          OrigPort_Notes
          OrigPort_DbClassType
          RecPort_City
          RecPort_CodeCity
          RecPort_CodeCountry
          RecPort_Country
          RecPort_Notes
          RecPort_DbClassType
          TypeShipment
          VesselName
          VesselFlagCode
          VoyageIdentification
          AirWayBillNumber
          FlightNumber
          BillOfLadingNumber
          CarrierTrakingNumber
          CarrierPRONumber
          BillingClientName
          ModeOfTransport_Code
          ModeOfTransport_DbClassType
          ModeOfTransport_Description
          ModeOfTransport_Flags
          ModeOfTransport_IsContainerized
          ModeOfTransport_Method
          ModeOfTransport_Status
          Division_GUID
          Division_Name
          LayoutType
          VolumeWeightUnit
          AreaUnit
          VolumeWeightFactor
          BookingNumber
          Item {
            Pieces
            PackageName
            Description
            IsContainer
            ItemGuid
          }
          customFields {
            id
            value
            clientId
            OperationNumber
            name
            internalName
            OperationType
            OperationGUID
            createdAt
            updatedAt
          }
        }
      }
    }`;

  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
    signal
  }).then((res) => res.json());
  return response.data.GetShipments;
};

function* fetchShipmentsSaga(data: any) {
  try {
    const response: Promise<any> = yield call(fetchShipments, data.payload);
    yield put(getShipmentsListSuccess(response));
  } catch (error) {
    yield put(getShipmentsListFail(error));
  }
}

function* getMilestoneConfigSH(data: any): any {
  try {
    const response: Promise<any> = yield call(getMilestoneConfigOperation, {
      OperationType: "SH",
      ...data.payload,
    });
    yield put(getMilestoneConfigSHSuccess(response));
  } catch (error) {
    yield put(getMilestoneConfigSHFail(error));
  }
}

export const fetchMilestoneEventsSH = async (data: any) => {
  const path = url.API_URL;
  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
    user = JSON.parse(getAuthUser);
  }

  const query = `query {
  GetMilestonesEventsName( clientId:${user.EMPRESA_ID} )
    { name }
  }`;

  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
    signal
  }).then((res) => res.json());
  return response.data.GetMilestonesEventsName;
};

function* fetchMilestoneEventsSHSaga(data: any) {
  try {
    const response: Promise<any> = yield call(fetchMilestoneEventsSH, data.payload);
    yield put(GetMilestonesEventsNameSHSuccess(response));
  } catch (error) {
    yield put(GetMilestonesEventsNameSHFail(error));
  }
}

export const fetchMilestoneEventsSHByGUID = async (data: any) => {
  const path = url.API_URL;
  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
    user = JSON.parse(getAuthUser);
  }

  const query = `query {
  GetMilestonesEventsNameByGUID( clientId:${user.EMPRESA_ID}, GUID: "${data.GUID}" )
    { 
      clientId
      Date
      Name
 
    }
  }`;

  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
    signal
  }).then((res) => res.json());
  return response.data.GetMilestonesEventsNameByGUID;
};

function* fetchMilestoneEventsSHByGUIDSaga(data: any) {
  try {
    const response: Promise<any> = yield call(fetchMilestoneEventsSHByGUID, data.payload);
    yield put(GetMilestonesEventsNameSHByGUIDSuccess(response));
  } catch (error) {
    yield put(GetMilestonesEventsNameSHByGUIDFail(error));
  }
}

export const fetchShipmentHouses = async (data: any) => {
  const { GUID } = data;
  const path = url.API_URL;
  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
    user = JSON.parse(getAuthUser);
  }
  const query = `query {
  GetHousesShipmentMaster(Shipment: { 
    userId: ${user.id || ''},
    GUID: "${GUID}"
    }) {
    listData {
      Number
      Name
      id
      clientId
      Int
      AESITNInt
      AESStatus
      AESXTNInt
      AMSActionCode
      AMSNotifyParty1Name
      AMSNotifyParty1SCAC
      AMSNotifyParty2Name
      AMSNotifyParty2SCAC
      AgentPartType
      AirWaybillTotalsInKg
      AirWaybillWeightUnit
      AreShipperConsigneeRelated
      AreaPrecision
      Barcodes
      BillOfLadingGroupSimilarItems
      BillOfLadingWeightUnit
      BookingInt
      CargoStorage
      CarrierName
      ConsigneeName
      CreatedByName
      CreatedOn
      CreatorNetworkID
      CutoffDate
      DbClassType
      DeclaredValue
      DeliveryAgentName
      DescriptionOfGoods
      DestinationAgentName
      DestinationPickupEntityName
      DestinationPortSchedule
      Direction
      DoNotUseAgent
      DocumentTemplateName
      EntryInt
      EstimatedArrivalDate
      EstimatedDepartureDate
      ExecutedCityCode
      ExecutedPlace
      FillDocsWithAccountingInfo
      Flags
      GUID
      GenerateCommissionsAsExpenses
      GenerateOneTransactionPerEntity
      GroupChargesInLiquidation
      HasGlobalAgentParticipation
      HasGlobalSalesManParticipation
      InsuranceInt
      IntermediateConsigneeName
      IsAirWayBillDetailExpanded
      IsBillOfLadingDetailExpanded
      IsCargoManifestDetailExpanded
      IsFullContainerLoad
      IsRoutedTransaction
      IsTrackingEmailSent
      IssuedByName
      LastDateOfDeparture
      LastPortOfDepartureSchedule
      LengthPrecision
      LengthUnit
      ManifestInt
      MasterGUID
      MaximumPieces
      ModeOfTransportCode
      Notes
      NotifyPartyName
      OceanCarriersInterfaceMessageVersion
      OriginPortSchedule
      PickupDate
      ProfitOrder
      ReceivedAtNetworkID
      RoutingInstructions
      SalesManPartType
      Service
      ShipperName
      ShowContainerDetails
      ShowDetailsInLiquidation
      ShowDimensionsDetailedInAWB
      ShowDimensionsInAWB
      ShowWHRsInCargoManifest
      SmartBorderInt
      SplitTaxedFromNonTaxedTransactions
      SpottingDate
      Status
      TotalPieces
      TotalVolume
      TotalVolumeWeight
      TotalWeight
      Type
      UseNotesAsMarksIntsInBL
      Version
      VolumePrecision
      VolumeUnit
      VolumeWeightPrecision
      WaybillNotes
      WeightPrecision
      WeightUnit
      DelPort_CodeCity
      DelPort_CodeCountry
      DelPort_Method
      DelPort_City
      DelPort_Country
      DelPort_Notes
      DelPort_DbClassType
      DestPort_CodeCity
      DestPort_CodeCountry
      DestPort_Method
      DestPort_City
      DestPort_Country
      DestPort_Notes
      DestPort_DbClassType
      LastPortDep_CodeCity
      LastPortDep_CodeCountry
      LastPortDep_Method
      LastPortDep_City
      LastPortDep_Country
      LastPortDep_Notes
      LastPortDep_DbClassType
      OrigPort_CodeCity
      OrigPort_CodeCountry
      OrigPort_Method
      OrigPort_City
      OrigPort_Country
      OrigPort_Notes
      OrigPort_DbClassType
      RecPort_CodeCity
      RecPort_CodeCountry
      RecPort_Method
      RecPort_City
      RecPort_Country
      RecPort_Notes
      RecPort_DbClassType
      VesselName
      VesselFlagCode
      VoyageIdentification
      AirWayBillNumber
      FlightNumber
      BillOfLadingNumber
      CarrierTrakingNumber
      CarrierPRONumber
      TypeShipment
      BillingClientName
      ModeOfTransport_Code
      ModeOfTransport_DbClassType
      ModeOfTransport_Description
      ModeOfTransport_Flags
      ModeOfTransport_IsContainerized
      ModeOfTransport_Method
      ModeOfTransport_Status
      Division_GUID
      Division_Name
      LayoutType
    }
  }
}
`;
  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
    signal
  }).then((res) => res.json());
  return response.data.GetHousesShipmentMaster;
};

function* fetchShipmentsHousesSaga(data: any) {
  try {
    const response: Promise<any> = yield call(fetchShipmentHouses, data.payload);
    yield put(getShipmentsHousesSuccess(response));
  } catch (error) {
    yield put(getShipmentsHousesFail(error));
  }
}


function* ShipmentsSaga() {
  yield takeLatest(ShipmentsTypes.GET_SHIPMENTS, fetchShipmentsSaga);
  yield takeLatest(ShipmentsTypes.GET_MILESTONESCONFIG_SH, getMilestoneConfigSH)
  yield takeLatest(ShipmentsTypes.GET_MILESTONESEVENTSNAME_SH, fetchMilestoneEventsSHSaga)
  yield takeLatest(ShipmentsTypes.GET_MILESTONESEVENTSNAME_BYGUID_SH, fetchMilestoneEventsSHByGUIDSaga)
  yield takeLatest(ShipmentsTypes.GET_SHIPMENTS_HOUSES, fetchShipmentsHousesSaga)
}

export default ShipmentsSaga;
